import { useRef, useState, useEffect } from "react";
import "./OTPInputBox.css";

function OTPInputBox(props) {
  const [otpValue, setOtpValue] = useState(["", "", "", "", "", ""]);
  const [currentFocus, setCurrentFocus] = useState(0);
  const inputBoxes = useRef(Array.from({ length: 6 }, () => null));

  useEffect(() => {
    inputBoxes.current[currentFocus]?.focus();
    inputBoxes.current[currentFocus]?.select();
    // eslint-disable-next-line
  }, [currentFocus]);

  useEffect(() => {
    typeof props.setValue === "function" && props.setValue(otpValue.join(""));
    // eslint-disable-next-line
  }, [otpValue]);

  const changeOTPValue = (key, index) => {
    if (key === "") {
      const updated = [...otpValue];
      updated[index] = "";
      setOtpValue(updated);
      if (index > 0) setCurrentFocus(index - 1);
      return;
    }

    if (/^\d+$/.test(key)) {
      const updated = [...otpValue];
      const digits = key.split("");

      digits.forEach((digit, i) => {
        const target = index + i;
        if (target < 6) updated[target] = digit;
      });

      setOtpValue(updated);
      setCurrentFocus(Math.min(index + digits.length, 5));
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const clipboard = (event.clipboardData || window.clipboardData)
      .getData("text")
      .trim();
    if (/^\d{6}$/.test(clipboard)) {
      setOtpValue(clipboard.split(""));
      setCurrentFocus(5);
    }
  };

  const renderInput = (_, index) => (
    <input
      key={index}
      inputMode="numeric"
      pattern="[0-9]*"
      data-cy={`otp${index + 1}`}
      ref={(el) => (inputBoxes.current[index] = el)}
      value={otpValue[index]}
      type="text"
      autoComplete="off"
      maxLength={1}
      style={{
        backgroundColor: "var(--primaryColor)",
        color: "var(--tertiaryColor6)"
      }}
      className={`${
        props.size === "small"
          ? "otp-input-box-size-small"
          : "otp-input-box-size"
      } max-width-54px padding-default ${
        props.error ? "border-bottom-otp-box-error" : "border-bottom-otp-box"
      } font-size-medium flex-center-children-horizontally text-align-center`}
      onInput={(e) => {
        e.preventDefault();
        e.stopPropagation();
        changeOTPValue(e.target.value, index);
      }}
      onClick={(e) => e.preventDefault()}
      onKeyUp={(e) => {
        if (e.key === "Backspace" && otpValue[index] === "") {
          if (index > 0) setCurrentFocus(index - 1);
        }
      }}
      onFocus={(e) => {
        e.preventDefault();
        inputBoxes.current[currentFocus]?.focus();
      }}
      onPaste={index === 0 ? handlePaste : undefined}
    />
  );

  return (
    <>
      <p className="text-align-center font-size-smaller letter-spacing-large text-transform-uppercase">
        {props.label || "PLEASE ENTER OTP"}
      </p>
      <div
        className={`flex-justify-content-space-between inherit-parent-width margin-top-small ${
          props.className || ""
        }`}
        data-cy="OTP-box"
      >
        {otpValue.map(renderInput)}
      </div>
    </>
  );
}

export default OTPInputBox;
